import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isLargeScreen' })
export class IsLargeScreenPipe implements PipeTransform {
    transform(width: number): boolean {
        const screenWidth = width || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        return screenWidth > 1080;
    }
}
